import { apiFetch } from "@/lib/api";

export type AdjustmentDetailLine = {
  id: number;
  sku: string;
  quantity: number;
  price: number | null;
};

export type AdjustmentDetailResponse = {
  adjustment: {
    id: number;
    mv_id: number | null;
    mv_number: string | null;
    display_number: string;
    kind: "adjustment" | "wastage" | "prototype";
    kind_label: string;
    status: string | null;
    comment: string | null;
    occurred_at: string | null;
    location_name: string | null;
    location_abbreviation: string | null;
  };
  lines: AdjustmentDetailLine[];
};

export function fetchAdjustmentDetail(adjustmentId: number): Promise<AdjustmentDetailResponse> {
  return apiFetch<AdjustmentDetailResponse>(`/api/mrp/adjustments/${encodeURIComponent(String(adjustmentId))}`);
}
